import React from "react";
import {
  Toolbar,
  SaveButton,
  Link,
  Button,
  Create,
  SimpleForm,
  AutocompleteInput,
  BooleanInput,
  Query,
  required,
  Pagination,
  List,
  Datagrid,
  // DeleteButton,
  EditButton,
  DateField,
  FunctionField,
  ReferenceField,
  CardActions
} from "react-admin";

import { sortBy, path } from "ramda";

import { parse } from "query-string";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import styled from "styled-components";

const StyledDiv = styled.div(props => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px"
}));

const validateForm = values => {
  const errors = {};
  if (!values.guide_id) {
    errors.guide_id = ["Guide is required"];
  }
  return errors;
};

const TourGuideCreateToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <CancelButton object={props.record} />
  </Toolbar>
);

const GuideData = ({ tourId }) => {
  return (
    <Query
      type="GET_LIST"
      resource="guides"
      const
      payload={{
        pagination: { page: 1, perPage: 1000 },
        filter: { tour_id: tourId, availability: true, guideBrieff },
        sort: { field: "name", order: "ASC" }
      }}
    >
      {({ data, total, loading, error }) => {
        if (loading) {
          return <p>Loading...</p>;
        }
        if (error) {
          return <p>ERROR</p>;
        }
        return (
          <AutocompleteInput
            label="Guide"
            choices={data}
            validate={required()}
            source="guide_id"
          />
        );
      }}
    </Query>
  );
};

const CreateTourGuideTitle = () => <span>Create Tour Guide</span>;

const CancelButton = record => (
  <Button
    component={Link}
    to={{
      pathname: `/tours/${record.object.tour_id}/4`
    }}
    label="Cancel"
  >
    <ArrowBackIcon />
  </Button>
);

export const TourGuideCreate = props => {
  const tour_id = parse(props.location.search).tour_id;
  const redirect = tour_id ? `/tours/${tour_id}/4` : "edit";

  return (
    <Create title={<CreateTourGuideTitle />} {...props}>
      <SimpleForm
        toolbar={<TourGuideCreateToolbar />}
        redirect={redirect}
        validate={validateForm}
      >
        <GuideData tourId={tour_id} />
        <BooleanInput label="Briefing Guide" onChange={handleValueChangeBoolBriefing} source="briefing_guide" />
      </SimpleForm>
    </Create>
  );
};
let guideBrieff = 0
const handleValueChangeBoolBriefing = element => { 
  if (guideBrieff === 0) {
    guideBrieff = 1
  }
  else{
    guideBrieff = 0
  }
 return guideBrieff;
};

const TourGuidePagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right"
};

const PendingRentalShowActions = ({ basePath, data, resource }) => (
  <CardActions style={cardActionStyle}></CardActions>
);

const CustomEditTourButton = ({ record = {} }) => {
  return (
    <EditButton
      to={{
        pathname: `/tours/${record.id}/4`
      }}
      basePath="tours"
      target="_blank"
      record={record}
      label="Edit Tour"
    />
  );
};

export const TourGuideList = props => {
  return (
    <List
      {...props}
      perPage={25}
      resource="tour_guides"
      pagination={<TourGuidePagination />}
      bulkActionButtons={false}
      filter={{ fromTour: true }}
      actions={<PendingRentalShowActions />}
    >
      <Datagrid>
        <FunctionField
          sortable={false}
          label="Tour"
          render={tour => {
            return `${tour.tour_name.tour_name_en}`;
          }}
        />
        <DateField
          label="Start Date"
          source="tour_start_date"
          sortable={false}
        />
        <DateField label="End Date" source="tour_end_date" sortable={false} />

        <FunctionField
          sortable={false}
          label="Guides"
          render={tour => {
            return (
              <StyledDiv align="end" padding="10px">
                {sortBy(path(["guide", "name"]), tour.tour_guides).map(
                  tguide => {
                    return (
                      <span>
                        {path(["guide", "name"], tguide)}{" "}
                        {tguide.briefing_guide ? <b>(B)</b> : ""}
                      </span>
                    );
                  }
                )}
              </StyledDiv>
            );
          }}
        />

        <ReferenceField
          sortable={false}
          source="location_id_1"
          reference="locations"
          linkType={false}
          label="Base"
        >
          <FunctionField
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        <ReferenceField
          sortable={false}
          source="location_id_2"
          reference="locations"
          linkType={false}
          label="Destination"
        >
          <FunctionField
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        {/* <DeleteButton /> */}
        <CustomEditTourButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/resources/tourGuides.js